import React from "react";
import styled from "styled-components";
import Contact from "./components/contact/Contact.js";
import Experience from "./components/experience/Experience.js";
import Header from "./components/header/Header.js";
import Intro from "./components/intro/Intro.js";
import Projects from "./components/projects/Projects.js";
import Reviews from "./components/reviews/Reviews.js";
import Skills from "./components/skills/Skills.js";
import Proficiency from "./components/proficiency/Proficiency.js";

const Home = () => {
  return (
    <Container>
      <Header />
      <Intro />
      <Skills />
      <Proficiency />
      <Experience />
      <Projects isBig={true} />
      <Projects />
      <Reviews />
      <Contact />
    </Container>
  );
};

const Container = styled.div`
  padding: 0px;
`;

export default Home;
